import api from '@/services/api/api'

class ShareLinkService {
  getAllLinks () {
    return api.get('share-links').then(result => {
      return result.data
    })
  }

  getBaseUrl () {
    return api.get('share-links/base-url').then(result => {
      return result.data
    })
  }

  getAvailableCollections () {
    return api.get('collection/view').then(result => {
      return result.data
    })
  }

  getLinkById (id) {
    return api.get('share-links/' + id).then(result => {
      return result.data
    })
  }

  saveLink (link) {
    return api.post('share-links', link)
  }

  removeLink (link) {
    return api.delete('share-links/' + link.id)
  }
}

export default new ShareLinkService()



// WEBPACK FOOTER //
// ./src/services/shareLinks/ShareLinkService.js